import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eaab650"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown-menu" }
const _hoisted_2 = ["aria-expanded"]

import { autoUpdate, offset, shift, useFloating } from '@floating-ui/vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownMenu',
  props: {
  fullWidth: {
    type: Boolean
  }
},
  setup(__props) {

const props = __props;

const isExpanded = ref(false);
const reference = ref(null);
const floating = ref(null);

const { x, y, strategy } = useFloating(reference, floating, {
  placement: 'bottom-start',
  middleware: [offset(24), shift({ padding: 20 })],
  whileElementsMounted: autoUpdate
});



const expand = () => {
  isExpanded.value = true;
};

const collapse = () => {
  isExpanded.value = false;
};

const toggle = () => {
  isExpanded.value ? collapse() : expand();
};

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "dropdown-trigger",
      ref_key: "reference",
      ref: reference,
      onClick: toggle,
      "aria-expanded": isExpanded.value,
      "aria-controls": "dropdown-content"
    }, [
      _renderSlot(_ctx.$slots, "trigger", {
        isExpanded: isExpanded.value,
        expand: expand,
        collapse: collapse
      })
    ], 8, _hoisted_2),
    (isExpanded.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "dropdown-content",
          ref_key: "floating",
          ref: floating,
          style: _normalizeStyle({
        position: _unref(strategy),
        top: `${_unref(y) ?? 0}px`,
        left: `${_unref(x) ?? 0}px`
      }),
          class: _normalizeClass(["dropdown-content", { 'full-width': __props.fullWidth }])
        }, [
          _renderSlot(_ctx.$slots, "content", {
            isExpanded: isExpanded.value,
            expand: expand,
            collapse: collapse
          })
        ], 6)), [
          [_directive_click_outside, { action: collapse, ignoredEl: reference.value }]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})